/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Sign_Invite_Code_InvalidInputs */

const en_common_sign_invite_code_invalid = /** @type {(inputs: Common_Sign_Invite_Code_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invalid invite code`)
};

const zh_common_sign_invite_code_invalid = /** @type {(inputs: Common_Sign_Invite_Code_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`邀请码无效`)
};

/**
* | output |
* | --- |
* | "Invalid invite code" |
*
* @param {Common_Sign_Invite_Code_InvalidInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_sign_invite_code_invalid = /** @type {((inputs?: Common_Sign_Invite_Code_InvalidInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Sign_Invite_Code_InvalidInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_sign_invite_code_invalid(inputs)
	return zh_common_sign_invite_code_invalid(inputs)
});
export { common_sign_invite_code_invalid as "common.sign.invite_code_invalid" }